var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinnerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 15,
    cy: 7,
    r: 7,
    fill: "#68CFC9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66666 16.875H11.3333",
    stroke: "#68CFC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.0417V16.875",
    stroke: "#68CFC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95834 4.83331H12.0417",
    stroke: "#68CFC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0417 4.83331V10.5C12.0417 11.4393 11.6685 12.3401 11.0043 13.0043C10.3401 13.6685 9.43931 14.0416 8.5 14.0416C7.56069 14.0416 6.65986 13.6685 5.99567 13.0043C5.33147 12.3401 4.95834 11.4393 4.95834 10.5V4.83331",
    stroke: "#68CFC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54167 9.79165C3.91739 9.79165 4.27772 9.64239 4.5434 9.37671C4.80908 9.11104 4.95833 8.7507 4.95833 8.37498C4.95833 7.99926 4.80908 7.63892 4.5434 7.37324C4.27772 7.10757 3.91739 6.95831 3.54167 6.95831C3.16594 6.95831 2.80561 7.10757 2.53993 7.37324C2.27426 7.63892 2.125 7.99926 2.125 8.37498C2.125 8.7507 2.27426 9.11104 2.53993 9.37671C2.80561 9.64239 3.16594 9.79165 3.54167 9.79165V9.79165Z",
    stroke: "#68CFC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4583 9.79165C13.8341 9.79165 14.1944 9.64239 14.4601 9.37671C14.7257 9.11104 14.875 8.7507 14.875 8.37498C14.875 7.99926 14.7257 7.63892 14.4601 7.37324C14.1944 7.10757 13.8341 6.95831 13.4583 6.95831C13.0826 6.95831 12.7223 7.10757 12.4566 7.37324C12.1909 7.63892 12.0417 7.99926 12.0417 8.37498C12.0417 8.7507 12.1909 9.11104 12.4566 9.37671C12.7223 9.64239 13.0826 9.79165 13.4583 9.79165V9.79165Z",
    stroke: "#68CFC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinnerIcon);
export default __webpack_public_path__ + "static/media/winnerIcon.718f524e68761667495f3f7b73f7a448.svg";
export { ForwardRef as ReactComponent };